"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManager_1 = require("../ApiManager");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiLogin = /** @class */ (function (_super) {
    __extends(ApiLogin, _super);
    function ApiLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.LOGIN_URL = "/auth/generateToken";
        _this.GET_TWITTER_OAUTH_TOKEN = "/authSns/twitterToken";
        _this.SNS_LOGIN_URL = "/authSns/snsToken";
        _this.LOGOUT_URL = "/users/logout";
        _this.UPDATE_MATURE_URL = "/users/setUser";
        _this.UPDATE_ALREADY_MATURE = "/preAuth/setMature";
        _this.UPDATE_LOGIN_COUNT = "/auth/loginCount";
        /**
         * Login Api
         * @param token : 사전인증 token값
         * @param isAlreadyMature : 사전인증 flag
         * @param request
         * @returns
         */
        _this.loginProc = function (token, isAlreadyMature, request, cToken) {
            var _a;
            var data = {
                userId: request.userId,
                password: request.password,
                auth: request.auth,
                is17: request.is17,
                deviceId: request.deviceId,
                partnerCode: request.partnerCode,
                cToken: cToken !== null && cToken !== void 0 ? cToken : "",
            };
            if (((_a = data.partnerCode) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                delete data.partnerCode;
            }
            return ApiConfig_1.Axios.Client({
                header: {
                    token: token,
                    isAlreadyMature: isAlreadyMature,
                },
                method: "post",
                url: _this.LOGIN_URL,
                data: data,
            });
        };
        /**
         * 소셜 로그인 api
         * @param credential
         */
        _this.snsLoginProc = function (credential, isAlreadyMature, token) {
            return ApiConfig_1.Axios.Client({
                header: { isAlreadyMature: isAlreadyMature, token: token },
                method: "post",
                url: _this.SNS_LOGIN_URL,
                data: credential,
            });
        };
        /**
         * twitter oauth token 획득 api
         */
        _this.getTwitterOauthToken = function (url) {
            var data = {
                callbackUrl: url,
            };
            return ApiConfig_1.Axios.Client({
                header: {},
                method: "post",
                url: _this.GET_TWITTER_OAUTH_TOKEN,
                data: data,
            });
        };
        /**
         * logout
         * @param token
         * @returns
         */
        _this.logoutProc = function (token) {
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: "post",
                url: _this.LOGOUT_URL,
            });
        };
        /**
         * 성인상태 업데이트 API
         * @param token
         * @param mature : view에 대한 성인 상태 변경 요청 1:성인 0:비성인
         * @param auth : 성인 인증 상태
         * @constructor
         */
        _this.updateMatureProc = function (token, mature, auth, uuid) {
            if (auth === void 0) { auth = 0; }
            if (uuid === void 0) { uuid = ""; }
            var data = {
                mature: mature,
                auth: auth,
            };
            if (auth === 0) {
                delete data.auth;
            }
            return ApiConfig_1.Axios.Client({
                header: {
                    token: token,
                    uuid: uuid,
                },
                method: "post",
                url: _this.UPDATE_MATURE_URL,
                data: data,
            });
        };
        /**
         * 사전인증 API
         * @param token : 최초에는 null로 이후에는 임시 발급된 token으로 update
         * @param mature 0: 비성인 1: 성인
         */
        _this.updateAlreadyMatureProc = function (token, mature) {
            return ApiConfig_1.Axios.Client({
                header: { token: token, mature: mature },
                method: "post",
                url: _this.UPDATE_ALREADY_MATURE,
            });
        };
        /**
         * 로그인 카운트 집계용
         * @param token
         * @param deviceId
         */
        _this.updateLoginCount = function (token, deviceId) {
            var data = {
                deviceId: deviceId,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: "post",
                url: _this.UPDATE_LOGIN_COUNT,
                data: data,
            });
        };
        return _this;
    }
    ApiLogin.getInstance = function (initValue) {
        if (!ApiLogin.classInstance) {
            this.classInstance = new ApiLogin(initValue);
        }
        return this.classInstance;
    };
    return ApiLogin;
}(ApiManager_1.ApiManager));
exports.default = ApiLogin;
